import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WINDOW } from '../constants/window';
import { ApiServiceService } from '../services/api-service.service';

@Injectable({
  providedIn: 'root',
})
export class AttributeMapperService {
  constructor(@Inject(WINDOW) private _window: Window) {}

  private _apiService = inject(ApiServiceService);
  private _httpClient = inject(HttpClient);

  // SM-3347: Auth headers removed - calls route through OBM-Core which handles authentication

  public saveAttributeMappings(attrMapData: any): Observable<any> {
    const apiUrl = `${this._apiService.dynamicEndPoint}/SaveAttributeDataMap`;
    return this._httpClient.post<any>(
      `${apiUrl}`,
      attrMapData
    );
  }
  public getAttributeMappings(formId: string | number): Observable<any> {
    console.log("this._apiService.dynamicEndPoint==>", this._apiService.dynamicEndPoint);
    const apiUrl = `${this._apiService.dynamicEndPoint}/GetFormDataMappingByFormId`;
    return this._httpClient.get<any>(
      `${apiUrl}?baseFormID=${formId}`
    );
  }
}
